/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Tab_FlowInputs */

const en_case_detail_tab_flow = /** @type {(inputs: Case_Detail_Tab_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flow`)
};

const pt_br2_case_detail_tab_flow = /** @type {(inputs: Case_Detail_Tab_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxo`)
};

/**
* | output |
* | --- |
* | "Flow" |
*
* @param {Case_Detail_Tab_FlowInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_tab_flow = /** @type {((inputs?: Case_Detail_Tab_FlowInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Tab_FlowInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_tab_flow(inputs)
	return pt_br2_case_detail_tab_flow(inputs)
});